import { z } from 'zod'

export const preprocessString = () =>
  z.preprocess((value: unknown) => {
    if (value === null || value === undefined) {
      return ''
    }
    return String(value)
  }, z.string())
